(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerAttachment = document.querySelector('.header-attachment');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener(
        'change',
        this.setHeaderHeight.bind(this)
      );

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);

      // Scroll listener is now added after observer finishes
      this.createObserver(() => {
        window.addEventListener('scroll', this.onScrollHandler, false);
      });
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty(
        '--header-height',
        `${this.header.offsetHeight}px`
      );
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver(callback) {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
        if (typeof callback === 'function') callback();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      const headerBottom = this.headerBounds?.bottom || this.header.offsetHeight;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > headerBottom) {
        this.header.classList.add('scrolled-past-header');

        if (this.headerAttachment) {
          this.headerAttachment.classList.add(
            `color-${this.getAttribute('data-color-scheme2')}`
          );
          this.headerAttachment.classList.remove(
            `color-${this.getAttribute('data-color-scheme')}`
          );
        }

        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > headerBottom) {
        this.header.classList.add('scrolled-past-header');

        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);
          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);
          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));

        if (this.headerAttachment) {
          this.headerAttachment.classList.remove(
            `color-${this.getAttribute('data-color-scheme2')}`
          );
          this.headerAttachment.classList.add(
            `color-${this.getAttribute('data-color-scheme')}`
          );
        }
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add(
        'shopify-section-header-hidden',
        'shopify-section-header-sticky'
      );
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove(
        'shopify-section-header-hidden',
        'shopify-section-header-sticky',
        'animate'
      );
    }

    closeMenuDisclosure() {
      this.disclosures =
        this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal =
        this.searchModal || this.header.querySelector('details-modal');
      if (this.searchModal) {
        this.searchModal.close(false);
      }
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kmd-pro-program"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initCarousel(root) {
    (root || document).querySelectorAll('.js-kmd-carousel').forEach(function (car) {
      if (car.dataset.kmdInit) return;
      car.dataset.kmdInit = '1';
      var wrap = car.closest('.kmd-carousel-wrap');
      if (!wrap) return;
      var prev = wrap.querySelector('.js-kmd-prev');
      var next = wrap.querySelector('.js-kmd-next');
      var step = function () {
        var item = car.querySelector('.kmd-ba-item');
        return item ? item.getBoundingClientRect().width + 16 : car.clientWidth * 0.8;
      };
      if (prev) prev.addEventListener('click', function () { car.scrollBy({ left: -step(), behavior: 'smooth' }); });
      if (next) next.addEventListener('click', function () { car.scrollBy({ left: step(), behavior: 'smooth' }); });
    });
  }
  function initVSlider(root) {
    (root || document).querySelectorAll('.js-vslider').forEach(function (sl) {
      if (sl.dataset.kmdInit) return;
      sl.dataset.kmdInit = '1';
      var slides = sl.querySelectorAll('.kmd-vslide');
      var dots = sl.querySelectorAll('.kmd-vdot');
      if (dots.length < 2) return;
      function go(i) {
        slides.forEach(function (s, idx) {
          var on = idx === i;
          s.hidden = !on;
          if (!on) { var v = s.querySelector('video'); if (v) { try { v.pause(); } catch (e) {} } }
        });
        dots.forEach(function (d, idx) {
          var on = idx === i;
          d.classList.toggle('is-active', on);
          d.setAttribute('aria-selected', on ? 'true' : 'false');
        });
      }
      dots.forEach(function (d, idx) { d.addEventListener('click', function () { go(idx); }); });
    });
  }
  function initAll(root) { initCarousel(root); initVSlider(root); }
  if (document.readyState !== 'loading') { initAll(); }
  else { document.addEventListener('DOMContentLoaded', function () { initAll(); }); }
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();

  } catch(e) { console.error(e); }
})();
})();
